export default __webpack_public_path__ + "static/media/BankLogo.2782a446.png";